import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import { toast } from "sonner";
import { boardFetch } from "../api";
import { useCompany, SectionHeader } from "../components";

const AuditTrail = () => {
  const { company } = useCompany();
  const [log, setLog] = useState([]);
  useEffect(() => {
    boardFetch(`/companies/${company.id}/audit-log`).then(setLog).catch((e) => toast.error(e.message));
  }, [company.id]);

  return (
    <div>
      <SectionHeader overline="Revisionssicher" title="Audit-Trail" />
      <p className="mb-6 text-sm text-white/45">Lückenlose Protokollierung aller Aktivitäten – zur Nachvollziehbarkeit und Haftungsminimierung.</p>
      <div className="relative border-l border-white/10 pl-6" data-testid="audit-trail">
        {log.length === 0 && <p className="text-sm text-white/35">Noch keine Aktivitäten</p>}
        {log.map((e) => (
          <div key={e.id} className="relative mb-6" data-testid="audit-entry">
            <span className="absolute -left-[27px] top-1 h-2.5 w-2.5 rounded-full bg-champagne" />
            <div className="flex items-center gap-2 text-sm text-white/85">
              <History size={14} className="text-white/30" />
              <span className="capitalize">{e.action.replace(/_/g, " ")}</span>
            </div>
            <p className="mt-1 text-xs text-white/45">{e.detail}</p>
            <p className="mt-0.5 text-[11px] text-white/30">{e.user} · {new Date(e.at).toLocaleString("de-CH")}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuditTrail;
